import { Loading, fillstring } from '@/components/common/Icons/Loading';
import { RefAttributes, forwardRef } from 'react';

import styles from './button.module.css';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	children: React.ReactNode;
	className?: string;
	variant?: 'primary' | 'secondary' | 'tertiary' | 'text' | 'shadow';
	size?: 'large' | undefined;
	isLoading?: boolean;
	loadingSize?: 'micro' | 'small' | 'large';
	isLoadingFill?: fillstring;
}

export const Button = forwardRef(function Button(
	{
		children,
		variant,
		size,
		isLoading = false,
		loadingSize = 'large',
		isLoadingFill = 'white',
		className,
		...props
	}: ButtonProps,
	ref: RefAttributes<HTMLButtonElement>['ref'] | undefined
) {
	return (
		<button
			role="button"
			className={`${styles.btn}${className ? ` ${className}` : ''}`}
			data-variant={variant}
			data-size={size}
			data-loading={isLoading}
			ref={ref}
			{...props}
		>
			{isLoading ? <Loading size={loadingSize} fill={isLoadingFill} /> : children}
		</button>
	);
});
